import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/styles';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border-[0.5px] border-white/20 backdrop-blur-sm px-2.5 py-0.5 text-xs font-bold',
  {
    variants: {
      variant: {
        default: 'bg-neutral-100/50 text-neutral-700',
        primary: 'bg-primary-100/50 text-primary-700',
        success: 'bg-success-50/50 text-success-700',
        warning: 'bg-warning-50/50 text-warning-700',
        error: 'bg-error-50/50 text-error-700',
        accent: 'bg-accent-100/50 text-accent-700',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, className }))} {...props}>
      {children}
    </span>
  );
}
